module.exports = __webpack_public_path__ + "static/media/1681411655200-DanCurrent-2-2.3c6aba10.jpg";